import { Row, Col, Form } from "react-bootstrap";
import { useState } from "react";
import apiCall from "components/Api/api";
import { handleError } from "components/Api/handleError";
import { useAuth } from "provider/AuthContext";
import { useNavigate } from "react-router-dom";
import { useToast } from "provider/ToastProvider";
import { useMobileVerifyContext } from "provider/MobileVerificationProvider";

const StepForm1 = () => {
  const { mobileVerify, mobileVerifyErrors, mobileVerifyDispatch } = useMobileVerifyContext();
  const { logout } = useAuth();
  const navigate = useNavigate();
  const { showSuccessToast, showSuccessToastSimple } = useToast();
  const [loading, setLoading] = useState(false);

  const updateField = (name, value) => {
    mobileVerifyDispatch({
      type: "UPDATE_MOBILE_VERIFY",
      payload: { [name]: value },
    });
    mobileVerifyDispatch({
      type: "SET_ERRORS_MOBILE_VERIFY",
      payload: { [name]: "" },
    });
  };

  const validateNo = () => {
    const errors = {};

    const mobile = mobileVerify?.mobile_no?.trim() || "";
    const mobileRegex = /^[6-9]\d{9}$/; // Indian 10-digit mobile starting with 6-9

    if (!mobile) {
      errors.mobile_no = "Mobile number is required";
    } else if (!mobileRegex.test(mobile)) {
      errors.mobile_no = "Please enter a valid 10-digit Indian mobile number";
    }

    mobileVerifyDispatch({
      type: "SET_ERRORS_MOBILE_VERIFY",
      payload: errors,
    });

    return Object.keys(errors).length === 0;
  };

  const handleSubmit = async () => {
    if (!validateNo()) return;

    setLoading(true);
    try {
      // You can call your API or move to next step here
      const formData = new FormData();
      formData.append("mobile_no", mobileVerify?.mobile_no);
      const url = `mobile-no-verification`;
      // return
      const response = await apiCall({
        url: url,
        method: "POST",
        data: formData,
      });
      if (response.status !== 200) {
        throw new Error(`Unexpected status code: ${response.status}`);
      }
      const apiData = response.data;
      if (apiData?.errors && Object.keys(apiData.errors).length > 0) {
        const firstKey = Object.keys(apiData.errors)[0];
        return mobileVerifyDispatch({
          type: "SET_ERRORS_MOBILE_VERIFY",
          payload: apiData.errors[firstKey][0],
        });
      }
      if (apiData?.status === 1) {
        // showSuccessToastSimple(apiData?.message);
        mobileVerifyDispatch({
          type: "MOBILE_VERIFY_SET_STEP",
          payload: 2,
        });
      }
      if (apiData?.status === 0) {
        showSuccessToastSimple(apiData?.message);
      }

    } catch (error) {
      console.error("Submission failed:", error);
      handleError(error, logout, navigate);
    } finally {
      setLoading(false);
    }
  };
 const handleClose = () => {
    mobileVerifyDispatch({ type: "MOBILE_VERIFY_TOGGLE", payload: false });
  }

  return (
    <Row className="pt-3 mt-2">
      <Col xs={12} className="my-5 text-center">
        <label className="font_colorfomr">
          You need to verify your phone number before posting a shared safari
        </label>
      </Col>

      <Col xs={12} className="mb-4 mt-3">
        <label className="Modal_label">
          Mobile Number <span className="necessary">*</span>
        </label>
        <div className="mb-3 field-sharedsafariform-mobile_no required">
          <Form.Control
            type="tel"
            className="form-control"
            placeholder="Enter Mobile number"
            value={mobileVerify?.mobile_no || ""}
            onChange={(e) => updateField("mobile_no", e.target.value)}
            isInvalid={!!mobileVerifyErrors?.mobile_no}
          />
          <Form.Control.Feedback type="invalid">
            {mobileVerifyErrors?.mobile_no || "Mobile number is required"}
          </Form.Control.Feedback>
        </div>
      </Col>
      <Col lg={12} className="margin-remove pt-5">
        <div className="creat-safri d-flex justify-content-end">
          <button
            type="button"
            className="cancel_btn_safari"
            onClick={handleClose}
            disabled={loading}
          >
            Cancel
          </button>
          <button
            type="button"
            className="btn safari_create_next  font_set w-auto ms-2 next_screen"
            onClick={handleSubmit}
            disabled={loading}
          >
            Next
          </button>
        </div>
      </Col>
    </Row>
  );
};

export default StepForm1;
